import * as angular from "angular";
import {IController} from "angular";
import {CommissionsService} from "../../services/commissions-service.service";

export class CommissionTimelineLogsComponent implements IController {
  commissionId: string;

  public timeline;

  constructor(private commissionsService: CommissionsService) {
  }

  $onInit() {
    this._getLogsTimeline();
  }

  $onChanges(changes) {
    if (changes.commissionId && !changes.commissionId.isFirstChange()) {
      this._getLogsTimeline();
    }
  }

  private _getLogsTimeline() {
    if (this.commissionId) {
      this.commissionsService.getLogsTimeline(this.commissionId)
        .then((timeline) => {
          this.timeline = timeline;
        })
    } else {
      this.timeline = undefined;
    }
  }


}

angular
  .module('bringoz.admin.commissions')
  .component('commissionTimelineLogs', {
    bindings: {
      commissionId: '<'
    },
    template: require('./commission-timeline-logs.html').default,
    controller: CommissionTimelineLogsComponent
  });
